<template>
  <div class="m-cont">
    <div class="header-section">
      <div class="title-row">
        <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="home">Home</a>
        <h1 class="page-title">{{ $t('pagamenti') || 'PAGAMENTI' }}</h1>
      </div>
    </div>

    <div class="tab-cont" id="style-3">
      <div class="container-fluid py-4 text-start">
        <div v-if="loading" class="text-center py-5">
          <div class="spinner-border text-success" role="status">
            <span class="visually-hidden">Caricamento in corso...</span>
          </div>
          <p class="mt-2 text-muted">Caricamento delle informazioni di pagamento...</p>
        </div>

        <div v-else>
          <!-- Banner di avviso in caso di errore di connessione in tempo reale -->
          <div v-if="error" class="alert alert-warning mb-4" role="alert">
            <i class="fas fa-exclamation-triangle me-2"></i> {{ error }}
          </div>

          <div class="row g-4">
            <!-- Card Stato Pagamento -->
            <div class="col-md-5">
              <div class="payment-card border-glow shadow-sm">
                <div class="payment-card-header bg-dark text-white p-3 fw-bold rounded-top">
                  Dettagli Abbonamento
                </div>
                <div class="payment-card-body p-4 bg-white rounded-bottom">
                  <div class="mb-4">
                    <label class="info-label text-muted d-block mb-1">STATO PAGAMENTO</label>
                    <span :class="['badge-status', paymentData.stato === 'pagato' ? 'badge-pagato' : 'badge-insoluto']">
                      {{ paymentData.stato === 'pagato' ? 'PAGATO' : 'PAGAMENTO RICHIESTO' }}
                    </span>
                  </div>

                  <div class="mb-3">
                    <label class="info-label text-muted d-block mb-1">PROSSIMO ADDEBITO</label>
                    <span class="info-value fw-bold text-dark">
                      {{ formatDate(paymentData.prossimoPagamento) }}
                    </span>
                  </div>

                  <div class="mb-3">
                    <label class="info-label text-muted d-block mb-1">TARIFFA MENSILE</label>
                    <span class="info-value fw-bold text-success" style="font-size: 1.25rem;">
                      {{ paymentData.tariffa.toFixed(2) }} €
                    </span>
                  </div>

                  <div class="mb-1">
                    <label class="info-label text-muted d-block mb-1">METODO DI PAGAMENTO</label>
                    <span class="info-value text-muted">
                      {{ paymentData.metodo }}
                    </span>
                  </div>

                  <div v-if="paymentData.stato === 'richiesto_pagamento' && paymentData.checkoutUrl" class="mt-4">
                    <a :href="paymentData.checkoutUrl" class="btn btn-success btn-lg w-100 fw-bold">
                      <i class="fab fa-stripe me-2"></i> Paga con Stripe
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <!-- Tabella Storico Fatturazione -->
            <div class="col-md-7">
              <div class="payment-card border-glow shadow-sm">
                <div class="payment-card-header bg-dark text-white p-3 fw-bold rounded-top">
                  Storico Pagamenti
                </div>
                <div class="payment-card-body p-0 bg-white rounded-bottom overflow-hidden">
                  <table class="table table-hover mb-0">
                    <thead class="table-light">
                      <tr>
                        <th class="ps-4">Data addebito</th>
                        <th>Importo</th>
                        <th class="pe-4 text-end">Stato transazione</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in paymentData.storico" :key="item.id">
                        <td class="ps-4 text-dark align-middle">{{ formatDate(item.data) }}</td>
                        <td class="fw-bold text-dark align-middle">{{ item.importo.toFixed(2) }} €</td>
                        <td class="pe-4 text-end align-middle">
                          <span :class="['status-dot', item.stato === 'successo' ? 'dot-success' : 'dot-danger']">
                            {{ item.stato === 'successo' ? 'Riuscito' : 'Fallito' }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '../store/store.js'

export default {
  name: 'Pagamenti',
  data() {
    return {
      store,
      loading: true,
      error: null,
      paymentData: {
        stato: 'pagato',
        prossimoPagamento: '',
        tariffa: 79.00,
        metodo: 'Carta di Credito (Visa **** 4242)',
        ultimoPagamento: '',
        storico: []
      }
    }
  },
  methods: {
    home() {
      this.$router.push({ name: "Gestionale" })
    },
    fetchPaymentStatus() {
      this.loading = true;
      this.error = null;
      this.axios.post(this.store.path + 'pagamenti/status', {}, {
        headers: {
          authorization: `Bearer ${JSON.parse(localStorage.token)}`
        }
      }).then(response => {
        if (response.data) {
          this.paymentData = response.data;
        }
        this.loading = false;
      }).catch(err => {
        console.error("Errore recupero stato pagamenti dal server:", err);
        this.error = "Impossibile caricare i dati in tempo reale. Mostrati dati simulati offline.";
        
        // Fallback locale in caso di errore o server offline
        const nextPaymentDate = new Date();
        nextPaymentDate.setMonth(nextPaymentDate.getMonth() + 1);
        nextPaymentDate.setDate(5);
        
        const lastPaymentDate = new Date();
        lastPaymentDate.setDate(5);

        this.paymentData = {
          stato: 'pagato',
          prossimoPagamento: nextPaymentDate.toISOString(),
          tariffa: 79.00,
          metodo: 'Carta di Credito (Visa **** 4242)',
          ultimoPagamento: lastPaymentDate.toISOString(),
          storico: [
            { id: '1', data: lastPaymentDate.toISOString(), importo: 79.00, stato: 'successo' },
            { id: '2', data: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString(), importo: 79.00, stato: 'successo' },
            { id: '3', data: new Date(new Date().setMonth(new Date().getMonth() - 2)).toISOString(), importo: 79.00, stato: 'successo' }
          ]
        };
        this.loading = false;
      });
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const d = new Date(dateString);
      return d.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' });
    }
  },
  beforeMount() {
    this.fetchPaymentStatus();
  }
}
</script>

<style scoped>
.m-cont {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f8f9fa;
}

.header-section {
  padding: 20px;
  background: white;
  box-shadow: 0 2px 5px rgba(0,0,0,0.05);
}

.title-row {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 20px;
}

.page-title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: bold;
  color: #333;
}

.tab-cont {
  flex-basis: 80%;
  overflow-y: auto;
  padding: 20px;
  background: #F5F5F5;
  width: 100vw;
}

/* Card custom */
.payment-card {
  border: 1px solid rgba(0,0,0,0.125);
  border-radius: 8px;
  background: #ffffff;
}

.payment-card-header {
  font-size: 1.1rem;
}

.info-label {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.info-value {
  font-size: 1.1rem;
}

/* Badge stati */
.badge-status {
  display: inline-block;
  padding: 6px 14px;
  font-size: 0.85rem;
  font-weight: 800;
  border-radius: 50px;
}

.badge-pagato {
  background-color: #d4edda;
  color: #155724;
}

.badge-insoluto {
  background-color: #f8d7da;
  color: #721c24;
}

/* Storico tabelle */
.status-dot {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  font-weight: 600;
}

.status-dot::before {
  content: '';
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.dot-success {
  color: #28a745;
}
.dot-success::before {
  background-color: #28a745;
}

.dot-danger {
  color: #dc3545;
}
.dot-danger::before {
  background-color: #dc3545;
}

.table th {
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #6c757d;
  border-bottom: 2px solid #dee2e6;
  padding: 12px 10px;
}

.table td {
  padding: 14px 10px;
  border-bottom: 1px solid #dee2e6;
}

#style-3::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1);
  background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar {
  width: 6px;
  background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 3px;
}

@media (max-width: 768px) {
  .title-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}
</style>
